/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Menu } from 'antd';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { groupSubsections, getLastRow } from './helper';
import { filterForm, getInputLabel } from '../Edit/helper';
import { propHasValue } from '../../components/DynamicFormNew/helper';
import { formPaths } from '../../helpers/form';

const Navigation = ({
  form = {},
  data = {},
  group = null,
  subsection = null,
  search = null,
  onGroupChange = () => { },
  mod,
}) => {
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [formGroups, setFormGroups] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  const goTo = useNavigate();
  const params = useParams();

  const hasSubSections = (f) => Object.keys(f)
    .map(key => propHasValue(f[key].subSection))
    .includes(true);

  const mapFormGroup = (f) => Object.keys(f).map(key => {
    const { label, showFormIf, position } = f[key];
    const fConf = {
      key,
      label,
      showFormIf,
      show: filterForm(f[key], data),
      items: [],
      position,
    };
    if (hasSubSections(f[key])) {
      fConf.items = {}
      const items = groupSubsections(f[key], true);
      Object.keys(items).forEach(i => {
        items[i].show = filterForm(items[i], data);
        fConf.items[i] = items[i];
      });
    }
    return fConf;
  });

  useEffect(() => {
    const formG = mapFormGroup(form).sort((a, b) => (a.position || 0) - (b.position || 0));
    const keys = []
    formG.forEach(f => {
      if (!keys.includes(f.key)) {
        keys.push(f.key);
      }
      if (f.items) {
        Object.keys(f.items).forEach(item => {
          if (!keys.includes(`${f.key}/${item}`)) {
            keys.push(`${f.key}/${item}`);
          }
        })
      }
    })
    let sGroup = group;
    if (!group && formG.length) {
      sGroup = formG[0].key;
    }
    if (subsection && keys.includes(`${sGroup}/${subsection}`)) {
      sGroup = `${sGroup}/${subsection}`;
    }
    if (sGroup === selectedGroup) {
      groupChanged();
    }
    
    setFormGroups(formG);

    if (!keys.includes(sGroup)) {
      sGroup = keys[0];
    }
    setSelectedGroup(sGroup);
  }, [form, group, subsection])

  useEffect(() => {
    groupChanged();
  }, [selectedGroup])

  // useEffect(() => {
  //   if (!selectedGroup && !formGroups.map(f => f.key).includes(selectedGroup)) {
  //     setSelectedGroup(formGroups.map(f => f.key)[0]);
  //   }
  // }, [formGroups])


  const groupChanged = () => {
    if (selectedGroup) {
      onGroupChange(selectedGroup);
      if (selectedGroup !== group) {
        const path = formPaths.view(mod);
        const [section, subSection, subgroup] = selectedGroup.split('/');
        goTo(`${generatePath(path, { ...params, group: section, subsection: subSection, subgroup: subgroup || undefined })}${search || ''}`);
      }
    }
    setTimeout(() => {
      const groups = Array.from(document.getElementsByClassName('group'));
      const rows = Array.from(document.querySelectorAll('.repetable-row-extra'));
      rows.forEach(row => {
        const inputs = Array.from(row.querySelectorAll('.input'));
        const lasts = getLastRow(inputs.map((i, ind) => ind), 4);
        if (lasts) {
          lasts.forEach(index => inputs[index].classList.add('last'));
        }
      });
      groups.forEach(group => {
        // const isRepeatable = Array.from(group.classList).includes('repeatable');
        const inputs = Array.from(group.querySelectorAll('.input'));
        // if (inputs.length && !isRepeatable) {
        //   if (inputs.length % 2 === 0) {
        //     inputs[inputs.length - 1].classList.add('last');
        //     inputs[inputs.length - 2].classList.add('last');
        //   } else {
        //     inputs[inputs.length - 1].classList.add('last');
        //   }
        // }
        // remove groups without inputs
        if (!inputs.length) {
          group.remove();
        }
      });
    }, 200)
  }

  return selectedGroup ? (
    <Menu
      mode="inline"
      defaultSelectedKeys={[selectedGroup]}
      selectedKeys={[selectedGroup]}
      defaultOpenKeys={selectedGroup ? [selectedGroup.split('/')[0]] : []}
      openKeys={openKeys}
      onOpenChange={(oKeys) => {
        setOpenKeys(oKeys)
      }}
      style={{ overflowY: 'auto', overflowX: 'hidden', }}
      onSelect={g => {
        setSelectedGroup(g.key);
      }}>
      {formGroups.filter(key => key.show).map(key => key.items && typeof key.items === 'object' && Object.keys(key.items).length > 0 ? (
        <Menu.SubMenu key={key.key} title={getInputLabel(key, data)}>
          {Object.keys(key.items).filter(item => key.items[item].show).map(item => (
            <Menu.Item key={`${key.key}/${item}`} level={2}>{getInputLabel(key.items[item], data)}</Menu.Item>
          ))}
        </Menu.SubMenu>
      ) : (
        <Menu.Item
          onClick={(props) => {
            if (params.subgroup && params.group === props.key) {
              const path = formPaths.view(mod);
              goTo(`${generatePath(path, params)}${search || ''}`)
            }
          }}
          key={key.key}
        >{getInputLabel(key, data)}</Menu.Item>
      ))}
    </Menu>
  ) : null;
}

export default Navigation;
